export default __webpack_public_path__ + "static/media/my_journey_part1_7.20f1e7f6.png";